<template>
  <div
    style="
      position: absolute;
      top: 60px;
      left: 0px;
      width: 100%;
      height: 100%;
      background-color: #fff;
    "
  >
    <div style="position: absolute; top: -30px; left: calc(50% - 97px)">
      <img src="/img/lok-logo.png" class="lok_logo" />
    </div>
    <div
      style="
        position: absolute;
        top: 140px;
        left: 10%;
        width: 80%;
        height: 20px;
        border: solid 0 #000;
        background-color: #fbe91d;
      "
    ></div>
    <div
      style="
        position: absolute;
        top: 120px;
        left: 0px;
        width: 100%;
        text-align: center;
      "
    >
      <span
        style="
          font-size: 25px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: -1px;
          text-align: center;
          color: #030721;
        "
        >{{$t('LOK Merge')}}</span
      >
    </div>
    <div
      style="
        margin-top: 180px;
        margin-left: 5%;
        width: 90%;
        height: 80px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.6;
        letter-spacing: -0.5px;
        text-align: center;
        color: #484c52;
      "
    >
      {{$t('LOK Merge desc 1')}}<br />
      {{$t('LOK Merge desc 2')}}
    </div>
    <div v-if="token != ''">
        <div
          style="
            margin-top: 80px;
            margin-left: 5%;
            width: 90%;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.4px;
            text-align: center;
            color: #444;
          "
        >
          * {{$t('token')}} {{token}}<br />
          * {{$t('kingdom name')}} {{from.name}}<br />
          * {{$t('kingdom level')}} {{from.level}}<br />
          * {{$t('kingdom power')}} {{from.power}}
        </div>
    </div>
    <div v-if="token == ''">
        <span
          style="
            margin-top: 80px;
            margin-left: 5%;
            width: 90%;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.4px;
            text-align: center;
            color: #444;
          "
        >
          {{$t('err_invalid_token')}}
        </span>
    </div>
    <div style="margin-top: 20px; width: 80%; height: 40px; margin-left: 10%; text-align: center;" v-if="log == null">
      <select v-model="worldId" style="width: 100%; text-align: center; font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.46;
  letter-spacing: -0.33px;
  text-align: center;
  color: #444;">
        <option value=0>{{$t('select_continent')}}</option>
        <option v-for="(worldId, index) in worldIds"
              v-bind:key="index" v-bind:value="`${worldId}`">{{worldId}} {{$t('continent')}}</option>
      </select>
    </div>
    <div style="margin-top: 20px; width: 80%; height: 260px; margin-left: 10%; text-align: center;" v-if="log != null">
      <span
          style="
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.4px;
            color: #444;
          "
        >
          * {{$t('move continent')}} {{log.worldId}}<br/>
          * {{$t('status')}} {{log.status}}<br/><br/>
          {{$t('LOK Merge desc 3')}}<br/>
          {{$t('LOK Merge desc 4')}}<br/>
          {{$t('LOK Merge desc 5')}}<br/>
          {{$t('LOK Merge desc 6')}}
        </span>
    </div>
    <div  v-if="log != null"
        style="
          margin-top: 20px;
          margin-left: 15%;
          width: 70%;
          height: 60px;
          padding: 14px;
          border-radius: 30px;
          border: solid 1px #dfe5ef;
          background-color: #d14c3e;
          text-align: center;
        "
        @click="onCancel()"
      >
        <span
          style="
            font-size: 18px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.45px;
            color: #fff;
          "
          >{{$t('cancel')}}</span
        >
      </div>
    <div
      style="
        margin-top: 20px;
        margin-left: 15%;
        width: 70%;
        height: 200px;
      "
      v-if="log == null"
    >
      <div
        style="
          margin-top: 0px;
          margin-left: 0px;
          width: 100%;
          height: 60px;
          padding: 14px;
          border-radius: 30px;
          border: solid 1px #dfe5ef;
          background-color: #d14c3e;
          text-align: center;
        "
        @click="onGoogleLogin()"
      >
        <span
          style="
            font-size: 18px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.45px;
            color: #fff;
          "
          >Google</span
        >
      </div>
      <div
        style="
          margin-top: 10px;
          margin-left: 0px;
          width: 100%;
          height: 60px;
          padding: 14px;
          border-radius: 30px;
          border: solid 1px #d6dbe5;
          background-color: #ffffff;
          text-align: center;
        "
        @click="onAppleLogin()"
      >
        <span
          style="
            font-size: 18px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.45px;
            color: #000000;
          "
          >Apple</span
        >
      </div>
      <div
        style="
          margin-top: 10px;
          margin-left: 0px;
          width: 100%;
          height: 60px;
          padding: 14px;
          border-radius: 30px;
          border: solid 1px #dfe5ef;
          background-color: #3d5a96;
          text-align: center;
        "
        @click="onFacebookLogin()"
      >
        <span
          style="
            font-size: 18px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.45px;
            color: #fff;
          "
          >Facebook</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "@/components";
import { Popover } from "element-ui";
import axios from "axios";
import * as facebook from "../utils/facebook.js";
import * as apple from "../utils/apple.js";
import * as google from "../utils/google.js";

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
  },
  methods: {
    onGoogleLogin: async function() {
      if (this.worldId == 0) {
        alert(this.$t('select continent first'));
        return;
      }
      window.google.login(this.from._id, this.worldId);
    },
    onFacebookLogin: async function() {
      if (this.worldId == 0) {
        alert(this.$t('select continent first'));
        return;
      }
      window.facebook.login(this.from._id, this.worldId);
    },
    onAppleLogin: async function() {
      if (this.worldId == 0) {
        alert(this.$t('select continent first'));
        return;
      }
      window.apple.login(this.from._id, this.worldId);
    },
    onCancel: async function() {
      let ret = await axios.post(
        `https://lok-api-live.leagueofkingdoms.com/api/moveklaytn/cancel`,
        {kingdomId: this.log.kingdomId}
      );

      location.reload();
    },
    getFromInfo: async function (token) {
      let ret = await axios.post(
        `https://lok-klay-api-live.leagueofkingdoms.com/api/moveklaytn/from`,
        {token: token}
      );

      console.log("ret - ", ret);

      if (ret.data.result == true) {
        this.from = ret.data.from;
      }      
      else {
        this.token = '';
      }

      ret = await axios.post(
        `https://lok-api-live.leagueofkingdoms.com/api/moveklaytn/to`,
        {kingdomId: this.from._id}
      );

      if (ret.data.log != null) {
        this.log = ret.data.log;
      }      

      console.log("ret - ", ret);
    },
  },
  async mounted() {
    this.token = this.$route.params.token;

    await this.getFromInfo(this.token);

    window["apple"] = apple;
    window["google"] = google;
    window["facebook"] = facebook;
  },
  data: function () {
    return {
      token: '',
      from: {
        _id: "",
        name: "",
        level: "",
        power: 0
      },
      log: null,
      worldId: 0,
      worldIds:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26]
    };
  },
};
</script>
<style>
img.lok_logo {
  width: 195px;
  height: 116px;
  object-fit: contain;
}
</style>
